module.exports = __webpack_public_path__ + "images/lab/sub-todos-172420ea829bb7123f20cc39843fda58.jpg";